export default __webpack_public_path__ + "static/logo_black-9837760aa5d95bee2018f849fdf2c70c.svg";